import { z } from "zod";
import { Timestamp } from "firebase/firestore";

export const timestamp = z.custom<Timestamp>(
  (value) => value instanceof Timestamp,
  {
    message: `Expected a Firestore Timestamp.`,
  },
);
